module.exports = __webpack_public_path__ + "img/podcast_spotify.2dde3266.png";